<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="600px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Rejection reason</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container>
        <custom-form method="put" :action="url" @submitted="$emit('commented', $event)">
          <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <custom-textarea name="comment" label="Rejection Reason (ALERT!!!This will be sent to the client)" />
              </v-col>
              <v-col cols="12">
                <custom-button block color="primary">
                  <v-icon v-if="method === 'post'">mdi-close-octagon</v-icon>
                  <v-icon v-else>mdi-pencil</v-icon>
                  Reject
                </custom-button>
              </v-col>
            </v-row>
          </v-container>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    transaction: { required: true, type: Object },
  },
  data() {
    return {};
  },
  computed: {
    url() {
      return `api/v1/transactions/reject/${this.transaction.id}`;
    },
  },
  created() {},
};
</script>
